<template>
  <div>
    <user-base id="manageUser"></user-base>
    <group-user />
  </div>
</template>
<script>
import UserBase from '../../../components/user-management/user/UserBase.vue';
import GroupUser from '../../../components/user-management/user/GroupUser.vue';

export default {
  name: 'ManageUsers',
  components: {
    UserBase,
    GroupUser,
  },
  created() {
    this.$router.push({
      name: 'Home',
    });
  },
  mounted() {
    this.$_introUserManage();
  },
};
</script>
<style lang="stylus" scoped></style>
